var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateBTnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11412 0.692383V5.3328C6.11412 5.88944 6.53883 6.34688 7.08186 6.39877L7.18499 6.40367H11.8254V13.5428C11.8254 14.2955 11.243 14.9122 10.5041 14.9667L10.3976 14.9706H1.83065C1.07793 14.9706 0.461255 14.3882 0.406748 13.6493L0.402832 13.5428V2.1202C0.402832 1.36748 0.985296 0.750806 1.72409 0.696299L1.83065 0.692383H6.11412ZM5.60931 7.24102L4.09487 8.75544C3.81608 9.03422 3.81608 9.48627 4.09487 9.76505C4.37368 10.0439 4.82573 10.0439 5.10451 9.76505L5.40021 9.46935V11.401C5.40021 11.7953 5.71983 12.115 6.11412 12.115C6.50841 12.115 6.82803 11.7953 6.82803 11.401V9.46935L7.12373 9.76505C7.40252 10.0439 7.85456 10.0439 8.13335 9.76505C8.4122 9.48627 8.4122 9.03422 8.13335 8.75544L6.61893 7.24102C6.34014 6.96223 5.8881 6.96223 5.60931 7.24102ZM7.54194 0.723338C7.77196 0.772041 7.98746 0.87706 8.16837 1.0301L8.25585 1.11058L11.4072 4.26194C11.576 4.43076 11.6982 4.63749 11.7654 4.86213L11.7944 4.97585H7.54194V0.723338Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateBTnIcon);
export default __webpack_public_path__ + "static/media/updateBTnIcon.94a01548dc4729f44eeb20c4d569a762.svg";
export { ForwardRef as ReactComponent };